import React from 'react';
import SEO from '../components/SEO';
import './StaticPages.css';

function TermsPage() {
  return (
    <main className="static-page">
      <SEO 
        title="Terms of Use - E Media Forum"
        description="Terms of Use and conditions for using E Media Forum website and services."
      />
      
      <div className="page-header">
        <h1>Terms of Use</h1>
        <p className="last-updated">Last Updated: January 2025</p>
      </div>
      
      <div className="page-content">
        <section className="content-section">
          <h2>Acceptance of Terms</h2>
          <p>
            By accessing and using E Media Forum website, you accept and agree to be bound by the terms 
            and provision of this agreement. These Terms of Use govern your use of our website and services.
          </p>
        </section>
        
        <section className="content-section">
          <h2>Use of Content</h2>
          <p>
            All content published on E Media Forum, including articles, images, videos, and other materials, 
            is protected by copyright and other intellectual property laws. You may view, download, and print 
            content for personal, non-commercial use only.
          </p>
          <p>
            Redistribution, republication, or commercial use of our content requires prior written permission 
            from E Media Forum.
          </p>
        </section>
        
        <section className="content-section">
          <h2>User Conduct</h2>
          <p>When using our website, you agree not to:</p>
          <ul>
            <li>Use the site for any unlawful purpose or activity</li>
            <li>Attempt to gain unauthorized access to our systems</li>
            <li>Interfere with the proper functioning of the website</li>
            <li>Upload or transmit harmful or malicious content</li>
            <li>Violate any applicable laws or regulations</li>
          </ul>
        </section>
        
        <section className="content-section">
          <h2>Disclaimer</h2>
          <p>
            E Media Forum provides information on an "as is" basis. While we strive for accuracy, 
            we make no warranties about the completeness, reliability, or accuracy of the information 
            provided on our website.
          </p>
        </section>
        
        <section className="content-section">
          <h2>Limitation of Liability</h2>
          <p>
            E Media Forum shall not be liable for any direct, indirect, incidental, consequential, 
            or punitive damages arising from your use of our website or services.
          </p>
        </section>
        
        <section className="content-section">
          <h2>Changes to Terms</h2>
          <p>
            We reserve the right to modify these Terms of Use at any time. Changes will be effective 
            immediately upon posting on this page. Your continued use of the website constitutes 
            acceptance of any changes.
          </p>
        </section>
        
        <section className="content-section">
          <h2>Contact Information</h2>
          <p>
            If you have questions about these Terms of Use, please contact us at info@emediaforum.com
          </p>
        </section>
      </div>
    </main>
  );
}

export default TermsPage;